module.exports = __webpack_public_path__ + "img/uganda-purple-2.a1ed0e99.svg";